var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.type ? _c("el-tag", {
    style: {
      marginLeft: "10px",
      zoom: _vm.zoom || ""
    },
    attrs: {
      size: "mini",
      type: "info"
    }
  }, [_vm._v(_vm._s(_vm.source))]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };